module.exports = __webpack_public_path__ + "img/gx_03.300f072a.png";